{
  "en": {
    "button": {
      "actions": {
        "add": "Add",
        "back": "Back",
        "cancel": "Cancel",
        "close": "Close",
        "copyEmail": "Copy email",
        "create": "Create",
        "delete": "Delete",
        "display": "Display",
        "edit": "Edit",
        "hide": "Hide",
        "loading": "Loading",
        "more": "More actions",
        "move": "Move",
        "move_down": "Move down",
        "move_up": "Move up",
        "no": "No",
        "reactivateEmailAddress": "Reactivate email address",
        "reset": "Reset",
        "save": "Save",
        "save_changes": "Save changes",
        "save_message": "Save message",
        "saving": "Saving",
        "share": "Share",
        "startTour": "Start tour",
        "uploadingDocuments": "Uploading documents",
        "yes": "Yes"
      }
    }
  }
}
